var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cam",staticStyle:{"background-color":"#000","text-align":"center","width":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPlay),expression:"isPlay"}],ref:"camDOMidRef",staticClass:"video",attrs:{"id":_vm.camDOMid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }